module.exports = __webpack_public_path__ + "img/post_box_letter.cf6153e5.svg";